/**
 * Cast dne, podle ktere obrazovka vybira pozdrav (predloha `Main.dc.html`:
 * „Dobré dopoledne, Richarde").
 *
 * SKLONOVANI JMENA TADY NEZIJE. Krok MRGC1 ho presunul do `@reos/i18n`
 * (`vocativeCs`, `firstName`, `salutationCs`), protoze tentyz 5. pad potrebuje
 * i e-mail klientovi z CRM4 a backend do web-adminu nevidi (CLAUDE.md §8.2:
 * jedno SSOT, ktere jde zavolat). Obrazovka si vokativ bere odtamtud.
 */

/** Casti dne, podle kterych se vybira pozdrav (predloha: „Dobré dopoledne"). */
export type DayPart = 'morning' | 'forenoon' | 'afternoon' | 'evening';

/**
 * Cast dne podle hodiny. Hranice jsou tytez, jake mela obrazovka od UXR3 —
 * jen uz nejsou schovane uvnitr komponenty, takze jdou otestovat bez
 * posouvani systemoveho casu.
 */
export function dayPart(hour: number): DayPart {
  if (hour < 9) return 'morning';
  if (hour < 12) return 'forenoon';
  if (hour < 18) return 'afternoon';
  return 'evening';
}
